import React from 'react';


import { Main, NextCard, StyledSubscription, QuantityIndicator } from "./styled";












export function Stack({
  noteData,
  img,
  color,
  isSubdued = false,
  quantity,
  title,
  className,
  onClick })
{
  return /*#__PURE__*/(
    React.createElement(Main, { className: className, onClick: onClick }, /*#__PURE__*/
    React.createElement(NextCard, { testId: "stack-card" }), /*#__PURE__*/
    React.createElement(StyledSubscription, {
      subdued: isSubdued,
      img: /*#__PURE__*/
      React.createElement(React.Fragment, null,
      !isSubdued && /*#__PURE__*/
      React.createElement(QuantityIndicator, { $color: color }, quantity),

      img),


      noteData: noteData,
      title: title })));



}